import useMediaQuery from '@mui/material/useMediaQuery'
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Backdrop,
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Divider,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Checkbox,
  Avatar,
  Popover,
  Badge,
  Chip,
} from "@mui/material";
import dayjs from "dayjs";



// ** Layout Imports
// !Do not remove this Layout import
import Layout from '../../layouts/Layout'
import Icon from "components/icon";
import { useTheme, styled } from "@mui/material/styles";
import { useIndexLogic } from "screens/Dashboard/logic/index-logic";
import { GetFormatedDateStamp } from "components/formatDate";
import MonthlySubscriptionDialog from "screens/Dashboard/component/MonthlySubscriptionDialog";

// ** Navigation Imports
import VerticalNavItems from '../../navigation/vertical'
// import HorizontalNavItems from 'src/navigation/horizontal'

// ** Component Import
// Uncomment the below line (according to the layout type) when using server-side menu
// import ServerSideVerticalNavItems from './components/vertical/ServerSideNavItems'
// import ServerSideHorizontalNavItems from './components/horizontal/ServerSideNavItems'

import VerticalAppBarContent from './components/vertical/AppBarContent'
// import HorizontalAppBarContent from './components/horizontal/AppBarContent'

// ** Hook Import
import { useSettings } from '../hooks/useSettings'

import Chatbot from 'components/Chatbot';

const UserLayout = ({ children, contentHeightFixed, activeLink, showIcon, NavURL }) => {
  // ** Hooks
  const { settings, saveSettings } = useSettings()
    const theme = useTheme();
      const [showTrialPopup, setShowTrialPopup] = useState(true);
      const [dialogOpen, setDialogOpen] = useState(false);
      const { IndexProps } = useIndexLogic();
      const { onboardingStatus , navigate } = IndexProps;
       const getDaysCount = (endDate) => {
          const currentDate = dayjs();
          const end = dayjs(endDate);
          return end.diff(currentDate, "day");
        };

  // ** Vars for server side navigation
  // const { menuItems: verticalMenuItems } = ServerSideVerticalNavItems()
  // const { menuItems: horizontalMenuItems } = ServerSideHorizontalNavItems()
  /**
   *  The below variable will hide the current layout menu at given screen size.
   *  The menu will be accessible from the Hamburger icon only (Vertical Overlay Menu).
   *  You can change the screen size from which you want to hide the current layout menu.
   *  Please refer useMediaQuery() hook: https://mui.com/material-ui/react-use-media-query/,
   *  to know more about what values can be passed to this hook.
   *  ! Do not change this value unless you know what you are doing. It can break the template.
   */
  // settings.layout = 'vertical'
  // settings.mode = 'light'
  
  const hidden = useMediaQuery(theme => theme.breakpoints.down('lg'))
  if (hidden && settings.layout === 'horizontal') {
    settings.layout = 'vertical'
    settings.mode = 'light'
  }
  const subscriptionStatus = onboardingStatus && onboardingStatus.clientOnBoarding && onboardingStatus.clientOnBoarding?.subscriptionStatus.toLowerCase();
  
  return (
    <>
    <Layout
      hidden={hidden}
      settings={settings}
      saveSettings={saveSettings}
      contentHeightFixed={contentHeightFixed}
      activeLink={activeLink}
      showIcon={showIcon}
      NavURL = {NavURL}
      verticalLayoutProps={{
        navMenu: {
          navItems: VerticalNavItems()

          // Uncomment the below line when using server-side menu in vertical layout and comment the above line
          // navItems: verticalMenuItems
        },
        appBar: {
          content: props => (
            <VerticalAppBarContent
              hidden={hidden}
              settings={settings}
              saveSettings={saveSettings}
              toggleNavVisibility={props.toggleNavVisibility}
              pageTitle={activeLink}
              showIcon={showIcon}
              NavURL = {NavURL}
            />
          )
        }
      }}
      // {...(settings.layout === 'horizontal' && {
      //   horizontalLayoutProps: {
      //     navMenu: {
      //       navItems: HorizontalNavItems()

      //       // Uncomment the below line when using server-side menu in horizontal layout and comment the above line
      //       // navItems: horizontalMenuItems
      //     },
      //     appBar: {
      //       content: () => <HorizontalAppBarContent hidden={hidden} settings={settings} saveSettings={saveSettings} />
      //     }
      //   }
      // })}
    >
      {subscriptionStatus === 'paused'&& showTrialPopup && activeLink !== 'Dashboard' && (
               <Box
                 sx={{
                   mb: 0,
                   ml: 1,
                   transform: 'translateY(-12px)',
                   p: 3,
                 background:
                   "linear-gradient(90deg, #D09A0E  20%, #775C2B 100%)",
                   borderRadius: 1,
                   display: "flex",
                   justifyContent: "space-between",
                   alignItems: "center",
                   position: "relative",
                   overflow: "hidden",
                   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                 }}
               >
                 <Box sx={{ pr: 4, color: "white" }}>
                   <Typography
                     variant="h5"
                     sx={{
                       color: theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.68)' : "white",
                       fontWeight: 350,
                       mb: 1,
                       display: "flex",
                       alignItems: "center",
                       gap: 2.5,
                     }}
                   >
                     <Icon
                       icon="material-symbols:info-outline"
                       width={18}
                       height={18}
                       sx={{
                         mr: 6,
                         color: theme.palette.mode === 'dark' ? 'rgba(208, 212, 241, 0.68)' : "white",
                         opacity: 0.9,
                       }}
                     />
                         Limited Access 
                         <Chip label="Subscription Paused" size="small" sx={{
                           display: 'flex',
                           padding: '1.923px 7.693px 1.923px 5.77px',
                           justifyContent: 'center',
                           alignItems: 'center',
                           gap: '5.77px',
                           backgroundColor: '#FFFFFF',
                         }} /> 
                   </Typography>
                   <Typography
                     variant="body2"
                     sx={{
                       fontWeight: 260,
                       color: "white",
                       opacity: 1.0,
                       pl: "26px", // Add padding to match the icon width + margin
                     }}
                   >   
                   Your subscription is currently paused. Some features may be limited. Reactivate your subscription to restore full access.
                   </Typography>
                 </Box>
                 <Box
                   sx={{
                     display: "flex",
                     alignItems: "center",
                     gap: 2,
                     position: "relative",
                     paddingTop: "8px",
                   }}
                 >
                   
                 
                   <Button
                     variant="contained"
                     onClick={() => navigate('/settings#5')}
                     color="main"
                     size="small"
                     sx={{
                       whiteSpace: "nowrap",
                       backgroundColor: "white",
                       color: "primary.main",
                       "&:hover": {
                         backgroundColor: "rgba(255,255,255,0.9)",
                       },
                     }}
                   >
                     Manage Subscription
                   </Button>
                   <IconButton
                     size="small"
                     sx={{
                       color: "white",
                       padding: "4px",
                       "& svg": {
                         width: "18px",
                         height: "18px",
                       },
                       "&:hover": {
                         backgroundColor: "rgba(255,255,255,0.2)",
                       },
                     }}
                     onClick={() => setShowTrialPopup(false)}
                   >
                     <Icon icon="tabler:x" />
                   </IconButton>
                 </Box>
               </Box>
             )}  
  {subscriptionStatus === 'expired' && showTrialPopup && activeLink !== 'Dashboard' && (
  <Box
    sx={{
      mb: 2,
      ml: 1,
      transform: 'translateY(-12px)',
      p: 3,
      background: "linear-gradient(90deg, #D80027  20%, #720015 100%)",
      borderRadius: 1,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    }}
  >
    <Box sx={{ pr: 4, color: "white" }}>
      <Typography
        variant="h5"
        sx={{
          color: "white",
          fontWeight: 350,
          mb: 1,
          display: "flex",
          alignItems: "center",
          gap: 2.5,
        }}
      >
        <Icon
          icon="material-symbols:info-outline"
          width={18}
          height={18}
          sx={{
            mr: 6,
            color: "white",
            opacity: 0.9,
          }}
        />
        Unpaid Subscription 
        <Chip
          label="Subscription inactive"
          size="small"
          sx={{
            display: 'flex',
            padding: '1.923px 7.693px 1.923px 5.77px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5.77px',
            backgroundColor: '#FFFFFF',
          }}
        /> 
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 260,
          color: "white",
          opacity: 1.0,
          pl: "26px",
        }}
      >   
        Your payment has expired, and your subscription is inactive. Please update your payment details to restore full access.
      </Typography>
    </Box>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        position: "relative",
        paddingTop: "8px",
      }}
    >
      <Button
        variant="contained"
        onClick={() => setDialogOpen(true)}
        color="main"
        size="small"
        sx={{
          whiteSpace: "nowrap",
          backgroundColor: "white",
          color: "primary.main",
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.9)",
          },
        }}
      >
        Update Payment
      </Button>
      <IconButton
        size="small"
        sx={{
          color: "white",
          padding: "4px",
          "& svg": {
            width: "18px",
            height: "18px",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.2)",
          },
        }}
        onClick={() => setShowTrialPopup(false)}
      >
        <Icon icon="tabler:x" />
      </IconButton>
    </Box>
  </Box>
)}

      {children}
    </Layout>
    {/* <Chatbot /> */}
     <MonthlySubscriptionDialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
          />
    </>
    
  )
}

export default UserLayout
